var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.143 -3.547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.724,16.345H25.219V14.072a3.5,3.5,0,0,0-3.4-3.584H8.26a3.5,3.5,0,0,0-3.4,3.584v9.355a3.5,3.5,0,0,0,3.4,3.584h1.855v3.221a1.844,1.844,0,0,0,.965,1.66,1.67,1.67,0,0,0,1.844-.151l2.561-1.957a2.732,2.732,0,0,0,1.146.254h2.187l5.044,3.855a1.438,1.438,0,0,0,1.592.131,1.593,1.593,0,0,0,.834-1.434V30.039h1.437a2.948,2.948,0,0,0,2.866-3.018V19.363a2.948,2.948,0,0,0-2.866-3.018ZM12.4,30.988a.826.826,0,0,1-.923.076A.912.912,0,0,1,11,30.233V26.546a.455.455,0,0,0-.442-.465H8.26A2.591,2.591,0,0,1,5.74,23.427V14.072A2.591,2.591,0,0,1,8.259,11.42H21.815a2.591,2.591,0,0,1,2.519,2.653v9.355a2.591,2.591,0,0,1-2.519,2.653H18.969a.421.421,0,0,0-.259.089Zm17.3-3.967a2.04,2.04,0,0,1-1.983,2.088H25.845a.455.455,0,0,0-.442.465v3.018a.664.664,0,0,1-.352.6.6.6,0,0,1-.671-.055L19.217,29.2a.428.428,0,0,0-.259-.089h-2.33a1.811,1.811,0,0,1-.239-.016l2.724-2.081h2.7a3.5,3.5,0,0,0,3.4-3.584V17.275h2.505a2.04,2.04,0,0,1,1.983,2.088Zm-9.762-7.805H10.13a.466.466,0,0,1,0-.931h9.815a.466.466,0,0,1,0,.931Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.34a8813be412aa73d7d83e612c3b149d.svg";
export { ForwardRef as ReactComponent };